import './BetbookPostEditorDate.less';

import clsx from 'clsx';
import React from 'react';
import moment from 'moment';
import i18n from '../../../common/i18n';

const BetbookPostEditorDate = ({ date }) => {
    const startOfToday = moment().startOf('day');
    const endOfToday = moment().endOf('day');
    const endOfTomorrow = moment()
        .add(1, 'days')
        .endOf('day');
    const start = moment(date);
    const dayName = start.format('ddd');
    const expirationTime = start.format('HH:mm');
    const expirationDate = start.format('DD.MM.YYYY - HH:mm');
    const isPlayingToday = start.isBetween(startOfToday, endOfToday);
    const isPlayingTomorrow = start.isBetween(endOfToday, endOfTomorrow);
    const isPlayingLater = start.isAfter(endOfTomorrow);

    return (
        <div className="p-rel">
            <span
                className={clsx('capitalize no-wrap c-black-40 fs-14', {
                    'betbook-post-editor-date pr-10': isPlayingToday || isPlayingTomorrow,
                    'betbook-post-editor-title': isPlayingLater
                })}
            >
                {isPlayingToday
                    ? `${i18n('nui.betbook.date.today')} ${expirationTime} (${dayName})`
                    : isPlayingTomorrow
                    ? `${i18n('nui.betbook.date.tomorrow')} ${expirationTime} (${dayName})`
                    : `${expirationDate} (${dayName})`}
            </span>
        </div>
    );
};

export default BetbookPostEditorDate;
